export default __webpack_public_path__ + "static/media/kickDescriptionThumbnail.556543e4.svg";